import { useQuery } from '@tanstack/react-query';
import { getBlockedRefunds, getBlockedRefundsDates } from '../api/client';

export function useBlockedRefundsDates() {
  return useQuery({
    queryKey: ['blocked-refunds-dates'],
    queryFn: getBlockedRefundsDates,
    staleTime: 5 * 60 * 1000, // 5 minutes — the daily report changes at most once/day
  });
}

export function useBlockedRefunds(date: string | undefined) {
  return useQuery({
    queryKey: ['blocked-refunds', date],
    queryFn: () => getBlockedRefunds(date as string),
    enabled: !!date,
    staleTime: 60 * 1000,
  });
}
